import { createRender } from './types';

export const render = createRender(() => <button>This is an example test button</button>);

export default render;
